/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAccountSettings} from '../api'

 export const useQueryGetAccountSettings = createReactQueryHook('getAccountSettings', getAccountSettings)
